import { render } from "./CampingPage.vue?vue&type=template&id=23ce9a28"
import script from "./CampingPage.vue?vue&type=script&lang=js"
export * from "./CampingPage.vue?vue&type=script&lang=js"

import "./CampingPage.vue?vue&type=style&index=0&id=23ce9a28&lang=scss"

import exportComponent from "C:\\Users\\Ollie\\Apps\\lasource-hautesalpes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__